import styles from './styles.module.scss';
import { styleWrapper } from 'utilities/styleWrapper';
import { Button as ComponentButton } from 'components/Buttons/Button';

export const Wrapper = styleWrapper('div', styles['wrapper']);
export const Title = styleWrapper('h1', styles['title']);
export const MarginedTitle = styleWrapper(Title, styles['largeMarge']);
export const Button = styleWrapper(ComponentButton, styles['button']);
